<!-- RX-PRESCRIPTION Info component -->
<template>
  <md-card id="vision" :style="noMargins ? 'margin: 0; width:100%' : ''" :class="noMargins ? '' : 'md-with-hover'">
    <md-card-header class="md-card-header-icon md-card-header-primary">
      <div class="md-layout">
        <div class="card-icon" style="margin-left: 5px; margin-top: -7px; margin-right: 0px">
          <md-icon>assignment</md-icon>
        </div>
        <div :style="noMargins ? 'flex: 0; min-width: fit-content' : ''" class="md-layout-item">
          <h4 class="title" style="font-weight: 400">
            {{ isContactLensPrescription ? "Contact Lens Prescription" : "Glasses Prescription" }}
          </h4>
        </div>
        <div class="md-layout md-layout-item md-alignment-center-right">
          <md-button
            slot="title"
            :disabled="saveDisabled"
            :class="saveBtnClass"
            class="md-button md-sm"
            style="margin-top: 15px; margin-right: 10%"
            @click="saveNewRx(true)"
          >
            SAVE Rx
          </md-button>
          <md-button
            v-if="showNoRefraction"
            slot="title"
            :class="dispenseBtnClass"
            class="md-button"
            style="margin-top: 15px; margin-right: 10%; padding: 8px 10px"
            @click="dispenseRx"
            v-html="dispenseRxHtml"
          >
          </md-button>
          <md-button
            v-if="noMargins"
            slot="title"
            class="md-button md-primary"
            style="margin-top: 15px; padding: 8px 10px; text-transform: uppercase"
            @click="emitRxPreview"
            v-html="'<span>preview rx-report</span>'"
          >
          </md-button>
        </div>
        <div v-if="noMargins && !isContactLensPrescription">
          <div style="display: flex; align-items: center; justify-content: flex-end; width: 100%">
            <button @click="closeRxModal('rxModal')">
              <md-icon class="exit-icon">cancel</md-icon>
              <md-tooltip md-direction="bottom">Close Rx modal</md-tooltip>
            </button>
          </div>
        </div>
      </div>
    </md-card-header>

    <md-card-content>
      <div class="md-layout md-alignment-center">
        <div align="center" class="md-layout-item md-size-45" style="font-weight: bold">OD</div>
        <div align="center" class="md-layout-item md-size-10">&nbsp;</div>
        <div align="center" class="md-layout-item md-size-45" style="font-weight: bold">OS</div>
      </div>
      <hr style="margin-bottom: 10px; margin-top: 5px" />

      <div class="md-layout md-alignment-center">
        <div class="md-layout md-layout-item md-size-45">
          <div class="md-layout-item md-size-20">
            <md-field>
              <label class="mlabel" for="odSPH">Sphere</label>
              <md-input
                id="odSPH"
                :min="eyeService.ValidRanges.SPH.min"
                :max="eyeService.ValidRanges.SPH.max"
                :step="eyeService.ValidRanges.SPH.step"
                v-model="rxValues.odSPH"
                :class="{ positive: rxValues.odSPH > 0, negative: rxValues.odSPH <= 0 }"
                type="text"
                name="odSPH"
                md-dense
                @input="changedRx($event)"
                @blur="rxValues.odSPH = eyeService.preventOutOfRange($event, eyeService.ValidRanges.SPH)"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20">
            <md-field>
              <label class="mlabel" for="odCYL">Cylinder</label>
              <md-input
                id="odCYL"
                :min="eyeService.ValidRanges.CYL.min"
                :max="eyeService.ValidRanges.CYL.max"
                :step="eyeService.ValidRanges.CYL.step"
                v-model="rxValues.odCYL"
                :class="{ positive: rxValues.odCYL > 0, negative: rxValues.odCYL <= 0 }"
                type="text"
                name="odCYL"
                md-dense
                @input="changedRx"
                @blur="rxValues.odCYL = eyeService.preventOutOfRange($event, eyeService.ValidRanges.CYL)"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-15">
            <md-field>
              <label class="mlabel" for="odAXS">Axis</label>
              <md-input
                id="odAXS"
                :min="eyeService.ValidRanges.AXS.min"
                :max="eyeService.ValidRanges.AXS.max"
                :step="eyeService.ValidRanges.AXS.step"
                v-model="rxValues.odAXS"
                type="text"
                name="odAXS"
                md-dense
                @input="changedRx($event)"
                @blur="rxValues.odAXS = eyeService.preventOutOfRange($event, eyeService.ValidRanges.AXS)"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20">
            <md-field>
              <label class="mlabel" for="odPOW">Add</label>
              <md-input
                id="odPOW"
                :min="eyeService.ValidRanges.POW.min"
                :max="eyeService.ValidRanges.POW.max"
                :step="eyeService.ValidRanges.POW.step"
                v-model="rxValues.odPOW"
                type="text"
                name="odPOW"
                md-dense
                @input="changedRx($event)"
                @blur="rxValues.odPOW = eyeService.preventOutOfRange($event, eyeService.ValidRanges.POW)"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-25">
            <md-field style="width: 100%; max-width: 100%">
              <label class="mlabel" for="odDIS">Acuity</label>
              <span class="md-prefix">20/</span>
              <md-input
                id="odDIS"
                :min="eyeService.ValidRanges.DIS.min"
                :step="eyeService.ValidRanges.DIS.step"
                v-model="rxValues.odDIS"
                style="width: 100%; max-width: 100%"
                type="text"
                name="odDIS"
                md-dense
                @input="changedRx($event)"
                @blur="rxValues.odDIS = eyeService.preventOutOfRange($event, eyeService.ValidRanges.DIS)"
              ></md-input>
            </md-field>
          </div>
        </div>

        <div class="md-layout md-layout-item md-size-5">&nbsp;</div>

        <div class="md-layout md-layout-item md-size-45">
          <div class="md-layout-item md-size-20">
            <md-field>
              <label class="mlabel" for="osSPH">Sphere</label>
              <md-input
                id="osSPH"
                :min="eyeService.ValidRanges.SPH.min"
                :max="eyeService.ValidRanges.SPH.max"
                :step="eyeService.ValidRanges.SPH.step"
                v-model="rxValues.osSPH"
                :class="{ positive: rxValues.osSPH > 0, negative: rxValues.osSPH <= 0 }"
                type="text"
                name="osSPH"
                md-dense
                @input="changedRx($event)"
                @blur="rxValues.osSPH = eyeService.preventOutOfRange($event, eyeService.ValidRanges.SPH)"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20">
            <md-field>
              <label class="mlabel" for="osCYL">Cylinder</label>
              <md-input
                id="osCYL"
                :min="eyeService.ValidRanges.CYL.min"
                :max="eyeService.ValidRanges.CYL.max"
                :step="eyeService.ValidRanges.CYL.step"
                v-model="rxValues.osCYL"
                :class="{ positive: rxValues.osCYL > 0, negative: rxValues.osCYL <= 0 }"
                type="text"
                name="osCYL"
                md-dense
                @input="changedRx"
                @blur="rxValues.osCYL = eyeService.preventOutOfRange($event, eyeService.ValidRanges.CYL)"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-15">
            <md-field>
              <label class="mlabel" for="osAXS">Axis</label>
              <md-input
                id="osAXS"
                :min="eyeService.ValidRanges.AXS.min"
                :max="eyeService.ValidRanges.AXS.max"
                :step="eyeService.ValidRanges.AXS.step"
                v-model="rxValues.osAXS"
                type="text"
                name="osAXS"
                md-dense
                @input="changedRx($event)"
                @blur="rxValues.osAXS = eyeService.preventOutOfRange($event, eyeService.ValidRanges.AXS)"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20">
            <md-field>
              <label class="mlabel" for="osPOW">Add</label>
              <md-input
                id="osPOW"
                :min="eyeService.ValidRanges.POW.min"
                :max="eyeService.ValidRanges.POW.max"
                :step="eyeService.ValidRanges.POW.step"
                v-model="rxValues.osPOW"
                type="text"
                name="osPOW"
                md-dense
                @input="changedRx($event)"
                @blur="rxValues.osPOW = eyeService.preventOutOfRange($event, eyeService.ValidRanges.POW)"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-25">
            <md-field style="width: 100%; max-width: 100%">
              <label class="mlabel" for="osDIS">Acuity</label>
              <span class="md-prefix">20/</span>
              <md-input
                id="osDIS"
                :min="eyeService.ValidRanges.DIS.min"
                :step="eyeService.ValidRanges.DIS.step"
                v-model="rxValues.osDIS"
                style="width: 100%; max-width: 100%"
                type="text"
                name="osDIS"
                md-dense
                @input="changedRx($event)"
                @blur="rxValues.osDIS = eyeService.preventOutOfRange($event, eyeService.ValidRanges.DIS)"
              ></md-input>
            </md-field>
          </div>
        </div>
      </div>

      <div v-if="isContactLensPrescription">
        <div class="md-layout md-alignment-center">
          <div class="md-layout md-layout-item md-size-45">
            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="odBC">Base Curve</label>
                <md-input
                  id="odBC"
                  :min="eyeService.ValidRanges.BC.min"
                  :max="eyeService.ValidRanges.BC.max"
                  :step="eyeService.ValidRanges.BC.step"
                  v-model="rxValues.odBC"
                  type="text"
                  name="odBC"
                  md-dense
                  @input="changedRx($event)"
                  @blur="rxValues.odBC = eyeService.preventOutOfRange($event, eyeService.ValidRanges.BC)"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="odDIA">Diameter</label>
                <md-input
                  id="odDIA"
                  :min="eyeService.ValidRanges.DIA.min"
                  :max="eyeService.ValidRanges.DIA.max"
                  :step="eyeService.ValidRanges.DIA.step"
                  v-model="rxValues.odDIA"
                  type="text"
                  name="odDIA"
                  md-dense
                  @input="changedRx($event)"
                  @blur="rxValues.odDIA = eyeService.preventOutOfRange($event, eyeService.ValidRanges.DIA)"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="odCOL">Color</label>
                <md-input
                  id="odCOL"
                  v-model="rxValues.odCOL"
                  type="text"
                  name="odCOL"
                  md-dense
                  @input="changedRx($event)"
                ></md-input>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-5">&nbsp;</div>

          <div class="md-layout md-layout-item md-size-45">
            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="osBC">Base Curve</label>
                <md-input
                  id="osBC"
                  :min="eyeService.ValidRanges.BC.min"
                  :max="eyeService.ValidRanges.BC.max"
                  :step="eyeService.ValidRanges.BC.step"
                  v-model="rxValues.osBC"
                  type="text"
                  name="osBC"
                  md-dense
                  @input="changedRx($event)"
                  @blur="rxValues.osBC = eyeService.preventOutOfRange($event, eyeService.ValidRanges.BC)"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="osDIA">Diameter</label>
                <md-input
                  id="osDIA"
                  :min="eyeService.ValidRanges.DIA.min"
                  :max="eyeService.ValidRanges.DIA.max"
                  :step="eyeService.ValidRanges.DIA.step"
                  v-model="rxValues.osDIA"
                  type="text"
                  name="osDIA"
                  md-dense
                  @input="changedRx($event)"
                  @blur="rxValues.osDIA = eyeService.preventOutOfRange($event, eyeService.ValidRanges.DIA)"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="osCOL">Color</label>
                <md-input
                  id="osCOL"
                  v-model="rxValues.osCOL"
                  type="text"
                  name="osCOL"
                  md-dense
                  @input="changedRx($event)"
                ></md-input>
              </md-field>
            </div>
          </div>
        </div>

        <div class="md-layout md-alignment-center">
          <div class="md-layout md-layout-item md-size-45">
            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="odBRA">Brand</label>
                <md-input
                  id="odBRA"
                  v-model="rxValues.odBRA"
                  type="text"
                  name="odBRA"
                  md-dense
                  @input="changedRx($event)"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="odMAN">Manufacturer</label>
                <md-input
                  id="odMAN"
                  v-model="rxValues.odMAN"
                  type="text"
                  name="odMAN"
                  md-dense
                  @input="changedRx($event)"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="odQT">Quantity</label>
                <md-input
                  id="odQT"
                  :min="eyeService.ValidRanges.QT.min"
                  :max="eyeService.ValidRanges.QT.max"
                  :step="eyeService.ValidRanges.QT.step"
                  v-model="rxValues.odQT"
                  type="text"
                  name="odQT"
                  md-dense
                  @input="changedRx($event)"
                  @blur="rxValues.odQT = eyeService.preventOutOfRange($event, eyeService.ValidRanges.QT)"
                ></md-input>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-5">&nbsp;</div>

          <div class="md-layout md-layout-item md-size-45">
            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="osBRA">Brand</label>
                <md-input
                  id="osBRA"
                  v-model="rxValues.osBRA"
                  type="text"
                  name="osBRA"
                  md-dense
                  @input="changedRx($event)"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="osMAN">Manufacturer</label>
                <md-input
                  id="osMAN"
                  v-model="rxValues.osMAN"
                  type="text"
                  name="osMAN"
                  md-dense
                  @input="changedRx($event)"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33">
              <md-field>
                <label class="mlabel" for="osQT">Quantity</label>
                <md-input
                  id="osQT"
                  :min="eyeService.ValidRanges.QT.min"
                  :max="eyeService.ValidRanges.QT.max"
                  :step="eyeService.ValidRanges.QT.step"
                  v-model="rxValues.osQT"
                  type="text"
                  name="osQT"
                  md-dense
                  @input="changedRx($event)"
                  @blur="rxValues.osQT = eyeService.preventOutOfRange($event, eyeService.ValidRanges.QT)"
                ></md-input>
              </md-field>
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter md-alignment-space-around-center">
        <div class="md-layout-item md-size-90">
          <md-field id="comments">
            <label style="margin-left: 5px">Comments</label>
            <md-textarea @input="changedRx($event)" id="odComments" v-model="rxValues.ouCOM" />
          </md-field>
        </div>
      </div>
      <hr style="margin-top: 30px" />
    </md-card-content>
  </md-card>
</template>

<script>
import { bus } from "@/main"
import Swal from "sweetalert2"
import { mapGetters } from "vuex"
import EyeInfoService from "../../../services/eye-info.service"

export default {
  name: "InfoRX",
  props: ["bus", "mScreening", "mPatient", "noMargins", "prescriptionType", "showNoRefraction"],
  // props: {
  //   mScreening: {
  //     type: String,
  //     required: false,
  //     default: null,
  //   },
  //   mPatient: {
  //     type: String,
  //     required: false,
  //     default: null,
  //   },
  // },
  data() {
    return {
      enableSave: false,
      dispenseRxToggle: false,
      dispenseContactRxToggle: false,
      eyeService: EyeInfoService,
      rxValues: {
        odSPH: "",
        odCYL: "",
        odAXS: "",
        odPOW: "",
        odDIS: "",
        odBC: "",
        odDIA: "",
        odCOL: "",
        odBRA: "",
        odMAN: "",
        odQT: "",
        osSPH: "",
        osCYL: "",
        osAXS: "",
        osPOW: "",
        osDIS: "",
        osBC: "",
        osDIA: "",
        osCOL: "",
        osBRA: "",
        osMAN: "",
        osQT: "",
        ouCOM: ""
      }
    }
  },
  computed: {
    ...mapGetters(["rxInfo"]),
    getReader: function() {
      return sessionStorage.getItem("userID")
    },
    saveDisabled() {
      return !this.enableSave
    },
    saveBtnClass() {
      return this.enableSave ? "md-success" : "md-grey"
    },
    dispenseBtnClass() {
      return this.dispenseRxToggle || this.dispenseContactRxToggle ? "md-success" : "md-primary"
    },
    dispenseRxHtml() {
      return this.dispenseRxToggle || this.dispenseContactRxToggle  ? "<span>Dispense Refraction</span>" : "<span>No Refraction</b></span>"
    },
    isContactLensPrescription() {
      return this.prescriptionType === "contact"
    }
  },
  mounted: function () {
    bus.$on("saveRx", (data) => {
      this.saveNewRx()
    })
    sessionStorage.setItem("rxDispensed", "false")
    this.existsRx()
  },
  methods: {
    closeRxModal() {
      this.$emit("close", "rxModal")
    },
    emitRxPreview() {
      this.$emit("openRxPreview", this.rxValues)
    },
    changedRx() {
      this.$emit("changedRx", this.rxValues)
      this.enableSave = true
    },
    getRange: function () {
      let axisArray = new Array(37)
      for (let i = 0; i < 37; i++) {
        axisArray[i] = i * 5
      }
      return axisArray
    },

    async existsRx() {
      const screeningId = sessionStorage.getItem("storageID")
      const baseURL = process.env.VUE_APP_URL

      const type = !this.prescriptionType ? "glasses" : this.prescriptionType

      const url = `${baseURL}/prescription/${screeningId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        params: {
          type: type
        }
      }

      var vm = this

      await window.axios
        .get(url, config)
        .then((response) => {
          if (response.data != null) {
            vm.rxValues.odSPH = this.eyeService.formatValue(response.data.sphereOD, this.eyeService.ValidRanges.SPH)
            vm.rxValues.osSPH = this.eyeService.formatValue(response.data.sphereOS, this.eyeService.ValidRanges.SPH)

            vm.rxValues.odCYL = this.eyeService.formatValue(response.data.cylinderOD, this.eyeService.ValidRanges.CYL)
            vm.rxValues.osCYL = this.eyeService.formatValue(response.data.cylinderOS, this.eyeService.ValidRanges.CYL)

            vm.rxValues.odAXS = this.eyeService.formatValue(response.data.axisOD, this.eyeService.ValidRanges.AXS)
            vm.rxValues.osAXS = this.eyeService.formatValue(response.data.axisOS, this.eyeService.ValidRanges.AXS)

            vm.rxValues.odPOW = this.eyeService.formatValue(response.data.powerOD, this.eyeService.ValidRanges.POW)
            vm.rxValues.osPOW = this.eyeService.formatValue(response.data.powerOS, this.eyeService.ValidRanges.POW)

            vm.rxValues.odDIS = this.eyeService.formatValue(response.data.distanceOD, this.eyeService.ValidRanges.DIS)
            vm.rxValues.osDIS = this.eyeService.formatValue(response.data.distanceOS, this.eyeService.ValidRanges.DIS)

            vm.rxValues.odBC = this.eyeService.formatValue(response.data.baseCurveOD, this.eyeService.ValidRanges.BC)
            vm.rxValues.osBC = this.eyeService.formatValue(response.data.baseCurveOS, this.eyeService.ValidRanges.BC)

            vm.rxValues.odDIA = this.eyeService.formatValue(response.data.diameterOD, this.eyeService.ValidRanges.DIA)
            vm.rxValues.osDIA = this.eyeService.formatValue(response.data.diameterOS, this.eyeService.ValidRanges.DIA)

            vm.rxValues.odCOL = response.data.colorOD
            vm.rxValues.osCOL = response.data.colorOS

            vm.rxValues.odBRA = response.data.brandOD
            vm.rxValues.osBRA = response.data.brandOS

            vm.rxValues.odMAN = response.data.manufacturerOD
            vm.rxValues.osMAN = response.data.manufacturerOS

            vm.rxValues.odQT = this.eyeService.formatValue(response.data.quantityOD, this.eyeService.ValidRanges.QT)
            vm.rxValues.osQT = this.eyeService.formatValue(response.data.quantityOS, this.eyeService.ValidRanges.QT)

            vm.rxValues.ouCOM = response.data.commentsOU
          }
        })
        .catch((err) => {
          console.log("Rx STATUS: " + err)
        })
    },

    dispenseRx() {
      if (this.prescriptionType === 'contact') {
        this.dispenseContactRxToggle = !this.dispenseContactRxToggle
        sessionStorage.setItem("contactRxDispensed", this.dispenseContactRxToggle)
      } else {
        this.dispenseRxToggle = !this.dispenseRxToggle
        sessionStorage.setItem("rxDispensed", this.dispenseRxToggle)
      }
    },

    async saveNewRx(successModal = false) {
      const screeningId = sessionStorage.getItem("storageID")
      const baseURL = process.env.VUE_APP_URL

      const type = !this.prescriptionType ? "glasses" : this.prescriptionType

      const url = `${baseURL}/prescription/${screeningId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        params: {
          type: type
        }
      }

      const date = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ")

      var vm = this
      const data = {
        screeningID: screeningId,
        patientID: vm.mPatient,
        sphereOD: this.eyeService.removePositiveSignal(vm.rxValues.odSPH, this.eyeService.ValidRanges.SPH.allowedWords),
        sphereOS: this.eyeService.removePositiveSignal(vm.rxValues.osSPH, this.eyeService.ValidRanges.SPH.allowedWords),
        cylinderOD: this.eyeService.removePositiveSignal(vm.rxValues.odCYL, this.eyeService.ValidRanges.CYL.allowedWords),
        cylinderOS: this.eyeService.removePositiveSignal(vm.rxValues.osCYL, this.eyeService.ValidRanges.CYL.allowedWords),
        axisOD: this.eyeService.removePositiveSignal(vm.rxValues.odAXS),
        axisOS: this.eyeService.removePositiveSignal(vm.rxValues.osAXS),
        powerOD: this.eyeService.removePositiveSignal(vm.rxValues.odPOW),
        powerOS: this.eyeService.removePositiveSignal(vm.rxValues.osPOW),
        distanceOD: this.eyeService.removePositiveSignal(vm.rxValues.odDIS),
        distanceOS: this.eyeService.removePositiveSignal(vm.rxValues.osDIS),
        baseCurveOD: this.eyeService.removePositiveSignal(vm.rxValues.odBC),
        baseCurveOS: this.eyeService.removePositiveSignal(vm.rxValues.osBC),
        diameterOD: this.eyeService.removePositiveSignal(vm.rxValues.odDIA),
        diameterOS: this.eyeService.removePositiveSignal(vm.rxValues.osDIA),
        colorOD: vm.rxValues.odCOL,
        colorOS: vm.rxValues.osCOL,
        brandOD: vm.rxValues.odBRA,
        brandOS: vm.rxValues.osBRA,
        manufacturerOD: vm.rxValues.odMAN,
        manufacturerOS: vm.rxValues.osMAN,
        quantityOD: this.eyeService.removePositiveSignal(vm.rxValues.odQT),
        quantityOS: this.eyeService.removePositiveSignal(vm.rxValues.osQT),
        commentsOU: vm.rxValues.ouCOM,
        approved: "",
        approvedBy: "",
        approvedOn: date,
        createdBy: vm.getReader,
        createdAt: date,
        updatedBy: vm.getReader,
        updatedAt: date
      }

      try {
        await window.axios.post(url, data, config).catch((err) => {
          console.log(err)
        })
        this.enableSave = false
        if (successModal) {
          Swal.fire({
            title: "Rx Saved",
            text: "Prescription has been saved successfully.",
            icon: "success",
            confirmButtonText: "OK"
          })
        }
      } catch (err) {
        console.error("Error saving prescription:", err)
        Swal.fire({
          title: "Error",
          text: "Failed to save prescription. Please try again.",
          icon: "error",
          confirmButtonText: "OK"
        })
      }
    },

    async listHistoryRx(route) {
      const url = process.env.VUE_APP_URL + route
      const config = {
        headers: {
          "Content-Type": "application/json"
          //'Access-Control-Allow-Origin': '*',
        }
      }
      var vm = this
      const data = null

      console.log("listHistoryRx:GET " + url)
      await window.axios
        .get(url, data, config, { useCache: false })
        .then((r) => r.data) //.slice(1, 200)
        .then((doctors) => {
          if (vm.filterState) {
            this.doctorsList = doctors.filter((dr) => dr.State != "")
            vm.filterState = false
          } else {
            this.doctorsList = doctors
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
#vision {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.mlabel {
  font-size: 0.8em;
}

.md-button.md-grey {
  background-color: #d3d3d3 !important;
  color: #808080 !important;
}

.positive {
  -webkit-text-fill-color: green !important;
}

.negative {
  -webkit-text-fill-color: red !important;
}
</style>
